<template>
  <!-- Bọc ngoài bằng toolbar-card chuẩn style Album -->
  <div>
    <div style="margin-bottom: 12px;">
      <p class="card-title">Bộ lọc tìm kiếm</p>
      <p class="card-subtitle">Tìm kiếm dữ liệu điểm danh theo ngày, khối, lớp, trạng thái, tình trạng và tên học sinh
        (hoặc nội dung đơn xin nghỉ)</p>
    </div>

    <div class="wrap-toolbar">
      <!-- Khối bên trái: Chứa toàn bộ bộ lọc đầu vào -->
      <div class="toolbar-left">
        <el-date-picker
            v-model="localDate"
            type="date"
            placeholder="Chọn ngày"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            class="toolbar-datepicker"
            @change="applyFilter"
            :clearable="true"
            :editable="false"
        />

        <el-select
            v-model="localGrade"
            placeholder="Chọn khối"
            class="toolbar-select"
            clearable
            @change="handleGradeChange"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          />
        </el-select>

        <el-select
            v-model="localClass"
            placeholder="Chọn lớp"
            class="toolbar-select"
            @change="applyFilter"
            :clearable="true"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          />
        </el-select>

        <el-select
            v-model="localAbsentLetterStatus"
            placeholder="Trạng thái"
            class="toolbar-select"
            clearable
            @change="applyFilter"
        >
          <el-option label="Đang chờ" value="PENDING"/>
          <el-option label="Đã duyệt" value="APPROVED"/>
        </el-select>

        <el-input
            class="button-left-class"
            style="width: 300px"
            placeholder="Nhập tên, nội dung tìm kiếm"
            clearable
            v-model="keyword"
            @change="applyFilter"
            @keyup.enter.native="applyFilter"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="applyFilter"
          ></el-button>
        </el-input>
      </div>

      <!-- Khối bên phải: Chứa nút hành động phụ trợ -->
      <div class="toolbar-right">
        <el-button
            icon="el-icon-refresh"
            type="info"
            plain
            class="btn-action"
            @click="resetFilter"
        >
          Làm mới
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'AbsentLetterFilterBar',
  props: {
    date: {type: String, default: () => new Date().toISOString().substring(0, 10)},
    idClass: {type: [Number, String], default: null},
    idGrade: {type: [Number, String], default: null},
    absentLetterStatus: {type: String, default: null},
    keyword: {type: String, default: null},
  },
  data() {
    return {
      localDate: this.date,
      localClass: this.idClass,
      localGrade: this.idGrade,
      localAbsentLetterStatus: this.absentLetterStatus,
      localKeyWord: this.keyword,
    }
  },

  async created() {
    await this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    if (this.getAppTypeUserLogin === "plus") {
      await this.$store.dispatch('classStore/fetchDataClassListCommon');
    } else {
      await this.$store.dispatch('classStore/fetchDataClassInTeacher');
    }

    // set grade
    if (this.gradeOfSchoolList.length > 0) {
      this.localGrade = this.gradeOfSchoolList[0].id;
    }

    let classes = [];
    if (this.getAppTypeUserLogin === "plus") {
      classes = this.classListCommon.filter(x => x.idGrade === this.localGrade);
    } else if (this.getAppTypeUserLogin === "teacher") {
      classes = this.classInTeacher;
    } else {
      classes = this.classListCommon;
    }

    if (classes.length > 0) {
      this.localClass = null;
    }

    await this.$nextTick();
    this.applyFilter();
  },

  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapGetters('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    classList() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon.filter((x) => x.idGrade === this.localGrade)
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      } else return this.classListCommon
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  methods: {
    handleGradeChange() {
      this.localClass = null;
      this.applyFilter();
    },
    applyFilter() {
      this.$emit('change', {
        date: this.localDate,
        idClass: this.localClass,
        idGrade: this.localGrade,
        absentLetterStatus: this.localAbsentLetterStatus,
        keyword: this.keyword,
      })
    },
    resetFilter() {
      this.localDate = null
      this.getIdGrade()
      this.getIdClass()
      this.localAbsentLetterStatus = null
      this.applyFilter()
    },
    getIdGrade() {
      if (this.gradeOfSchoolList.length > 0) {
        this.localGrade = this.gradeOfSchoolList[0].id;
      }
    },
    getIdClass() {
      this.localClass = null;
    },
  },
  watch: {
    localGrade() {
      this.$nextTick(() => {
        this.localClass = null;
      });
    },
    type(v) {
      this.localType = v;
    },
    date(v) {
      this.localDate = v;
    },
    idClass(v) {
      this.localClass = v;
    },
    idGrade(v) {
      this.localGrade = v;
    },
    absentLetterStatus(v) {
      this.localAbsentLetterStatus = v;
    },
  }
}
</script>

<!-- Sử dụng scss scoped đồng bộ hoàn toàn style mượt mà của Album -->
<style lang="scss" scoped>
.toolbar-card {
  //display: flex;
  align-items: center;
  //gap: 12px;
  //flex-wrap: wrap;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #e8edf4;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
  margin-bottom: 16px;
}

.wrap-toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-datepicker {
  width: 180px !important;
}

.toolbar-select {
  width: 150px !important;

  &--wide {
    width: 190px !important;
  }
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.btn-action {
  border-radius: 10px !important;
  font-weight: 600;
  height: 38px;
  padding: 0 16px;
}

// ─── Ghi đè style Element UI Input gốc ──────────────────────────────────
/deep/ .el-input .el-input__inner,
/deep/ .el-select .el-input__inner {
  border-radius: 10px;
  border-color: #dbe4f0;
  height: 38px;
  line-height: 38px;
  transition: all .2s ease;
}

/deep/ .el-input .el-input__inner:focus,
/deep/ .el-select .el-input__inner:focus {
  border-color: #78a5e7;
  box-shadow: 0 0 0 3px rgba(120, 165, 231, 0.12);
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.button-left-class {
  margin-right: 5px;
  width: 135px;

  /deep/ .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

// ─── Tương thích thiết bị di động (Responsive) ──────────────────────────
@media (max-width: 768px) {
  .toolbar-card {
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    padding: 14px;
  }
  .toolbar-left, .toolbar-right {
    width: 100%;
  }
  .toolbar-datepicker, .toolbar-select, .toolbar-select--wide {
    width: 100% !important;
  }
  .btn-action {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
